//@ts-ignore
import { prune } from '@mindtickle/utils';
//@ts-ignore
import { getQuery, stringifyQueryObject } from '@mindtickle/utils/url';
import { getApplicationAccessLink, APPLICATIONS } from '~/components/ApplicationUrls';

const PROGRAMS_FILTER_MAP: { [x: string]: { [y: string]: string } } = {
  VISIBILITY: {
    INVITED: 'ASSIGNED',
    SUBSCRIBED: 'SUBSCRIBED',
    OPEN: 'PUBLIC',
    ACCESSIBLE: 'ALL_PROGRAMS',
  },
  SORT: {
    'A-Z': 'A_Z',
    RECENTLY_ACCESSED: 'RECENTLY_ACCESSED',
    RAF: 'ADDED_ON',
    AVERAGE_RATING: 'AVERAGE_RATING',
  },
  PINNED: {
    true: 'true',
  },
};

export const LEGACY_HASH_TO_ROUTE_MAP: { [x: string]: Function } = {
  '/courses/recent': () => getApplicationAccessLink(APPLICATIONS.LEARNER_READINESS_DASHBOARD),
  '/dashboard/results': (url: string) =>
    `${getApplicationAccessLink(APPLICATIONS.LEARNER_READINESS_WIDGET)}?id=${url.split('=')[1]}`,

  '/programs': (url: string) => {
    const { sort, visibility, pinned } = getQuery(url, ['sort', 'filter', 'pinned']);
    const queryObject = prune({
      filter: PROGRAMS_FILTER_MAP.VISIBILITY[visibility],
      sort: PROGRAMS_FILTER_MAP.SORT[sort],
      pinned: PROGRAMS_FILTER_MAP.PINNED[pinned],
    });
    return Object.keys(queryObject).length
      ? `${getApplicationAccessLink(
          APPLICATIONS.LEARNER_READINESS_PROGRAMS
        )}?${stringifyQueryObject(queryObject)}`
      : getApplicationAccessLink(APPLICATIONS.LEARNER_READINESS_PROGRAMS);
  },

  '/programs/program/:programId': (url: string) =>
    `${getApplicationAccessLink(APPLICATIONS.LEARNER_READINESS_PROGRAMS)}/${url.split('/')[3]}`,

  '/courses/series/:seriesId': (url: string) =>
    `${getApplicationAccessLink(APPLICATIONS.LEARNER_READINESS_PROGRAMS)}/${url.split('/')[3]}`,

  '/callai': (url: string) =>
    `${getApplicationAccessLink(APPLICATIONS.LEARNER_CALL_AI)}/${url.replace('/callai/', '')}`,

  '/singleton-callai': (url: string) =>
    `${getApplicationAccessLink(APPLICATIONS.SINGLETON_CALL_AI)}/${url.replace(
      '/singleton-callai/',
      ''
    )}`,

  '/participants': (url: string) => `${getApplicationAccessLink(APPLICATIONS.LEARNER_PEERS)}`,

  '/participants/:id': (url: string, userId: string) => {
    const id = url.split('/')[2];
    // eslint-disable-next-line no-console
    if (id === userId || id === 'me') {
      return `${getApplicationAccessLink(APPLICATIONS.LEARNER_PROFILE)}/${userId}`;
    } else {
      return `${getApplicationAccessLink(APPLICATIONS.LEARNER_PEERS)}/${id}`;
    }
  },
  '/new/ui/learner/module-library': (url: string) =>
    `${getApplicationAccessLink(APPLICATIONS.MODULE_LIBRARY)}${
      url.split('?')[1] ? `?${url.split('?')[1]}` : ''
    }`,
  '/modules': (url: string, _: string) =>
    `${getApplicationAccessLink(APPLICATIONS.MODULE_LIBRARY)}${
      url.split('?')[1] ? `?${url.split('?')[1]}` : ''
    }`,
  // '/voss/list': (url: string, _: string) =>
  //   `${getApplicationAccessLink(APPLICATIONS.TASKS)}${
  //     url.split('?')[1] ? `?${url.split('?')[1]}` : ''
  //   }`, uncomment when task link done
};
